/** @jsxImportSource @emotion/react */

import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppDispatch } from 'store/store';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { upsertTournamentUser } from '../../store/actions';
import PlayerForm, { SubmitPlayerForm } from '../components/player-form';
import useTournamentUsers from '../hooks/use-tournament-users';

function PlayerCreatePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { info } = useOrganizer();
  const { isProcessing } = useTournamentUsers();
  const [isLoading, setIsLoading] = useState(false);
  const { setHeaderContent } = useMainLayout();

  const breadcrumb = useMemo(
    () => (
      <UDBreadcrumbs
        className="my-10"
        breadcrumbs={[
          { label: 'Игроки', to: Pages.PLAYERS.INDEX },
          { label: 'Добавление игрока', to: Pages.PLAYERS.CREATE },
        ]}
      />
    ),
    [],
  );

  const onSubmit = useCallback<SubmitPlayerForm>(
    ({ values, formikHelpers }) => {
      if (!info) {
        return;
      }

      setIsLoading(true);

      const height = values.height && !isNaN(Number(values.height)) ? Number(values.height) : undefined;
      const weight = values.weight && !isNaN(Number(values.weight)) ? Number(values.weight) : undefined;

      dispatch(
        upsertTournamentUser({
          tournamentId: info.id,
          name: values.name,
          surname: values.surname,
          middleName: values.middleName,
          birthDate: values.birthDate,
          photo: values.photo && values.photo[0] instanceof File ? (values.photo as File[]) : undefined,
          height,
          weight,
        }),
      )
        .unwrap()
        .then((data) => {
          StepperMainTool.setByPath('stepper:main:createPlayer', true);
          navigate(Pages.PLAYERS.builders.view(data.id));
          toast.success('Игрок успешно создан');
        })
        .finally(() => {
          formikHelpers.setSubmitting(false);
          setIsLoading(false);
        });
    },
    [info, dispatch, navigate],
  );

  useEffect(() => {
    setHeaderContent(breadcrumb);
    return () => setHeaderContent(null);
  }, [breadcrumb, setHeaderContent]);

  return (
    <>
      <div className={'w-full px-6 pt-6'}>
        <PlayerForm onSubmit={onSubmit} isLoading={isProcessing || isLoading} />
      </div>
    </>
  );
}

export default PlayerCreatePage;
